import all from "@/assets/dashboard-home/ball.png";
import brasileirao from "@/assets/dashboard-home/brasileirao.png";
import laLiga from "@/assets/dashboard-home/la-liga.png";
import uefaChampions from "@/assets/dashboard-home/uefa-champions.png";
import uefaEur from "@/assets/dashboard-home/uefa-europe.png";
import premier from "@/assets/dashboard-home/premier.png";
import copaBrasil from "@/assets/dashboard-home/copa-brasil.png";
import bundesliga from "@/assets/dashboard-home/bundesliga.png";
import ligue1 from "@/assets/dashboard-home/ligue-1.png";
import erendivise from "@/assets/dashboard-home/eredivisie.png";
import libertadores from "@/assets/dashboard-home/libertadores.png";
import worldChampionship from "@/assets/dashboard-home/world-championship.png";
import caf from "@/assets/dashboard-home/caf.png";

import barcelona from "@/assets/dashboard-home/barcelona.png";
import realMadrid from "@/assets/dashboard-home/real-madrid.png";

// export const allLeaguesId = [
//   99, 302, 3, 4, 152, 349, 171, 168, 244, 18, 153, 346,
// ];
export const allLeaguesId = [];

export const leaguesIdName = {
  0: "Todas As Ligas",
  99: "Brasileirão",
  302: "La Liga",
  3: "UEFA Champions League",
  4: "UEFA Europe League",
  152: "Premier League",
  349: "Copa do Brasil",
  171: "Bundesliga",
  168: "Ligue 1",
  244: "Erendivise",
  18: "Libertadores",
  153: "World Championship",
  346: "CAF Champions",
};

export const leaguesNames = [
  "Serie A",
  "La Liga",
  "UEFA Champions League",
  "eurocups",
  "Premier League",
  "Copa do Brasil",
  "2. Bundesliga",
  "Ligue 1",
  "Eredivisie",
  "CONMEBOL Libertadores",
  "Championship",
  "CAF Champions League",
];

export const leaguesBackImage = {
  "Serie A": brasileirao,
  "La Liga": laLiga,
  "UEFA Champions League": uefaChampions,
  eurocups: uefaEur,
  "Premier League": premier,
  "Copa do Brasil": copaBrasil,
  "2. Bundesliga": bundesliga,
  "Ligue 1": ligue1,
  Eredivisie: erendivise,
  "CONMEBOL Libertadores": libertadores,
  Championship: worldChampionship,
  "CAF Champions League": caf,
};
export const leaguesData = [
  {
    text: "Todas",
    img: all,
    leagueId: 0,
  },
  {
    text: "Brasileirão",
    img: brasileirao,
    leagueId: 99,
  },
  {
    text: "La Liga",
    img: laLiga,
    leagueId: 302,
  },
  {
    text: "UEFA Champions League",
    img: uefaChampions,
    leagueId: 3,
  },
  {
    text: "UEFA Europe League",
    img: uefaEur,
    leagueId: 4,
  },
  {
    text: "Premier League",
    img: premier,
    leagueId: 152,
  },
  {
    text: "Copa do Brasil",
    img: copaBrasil,
    leagueId: 349,
  },
  {
    text: "Bundesliga",
    img: bundesliga,
    leagueId: 171,
  },
  {
    text: "Ligue 1",
    img: ligue1,
    leagueId: 168,
  },
  {
    text: "Erendivise",
    img: erendivise,
    leagueId: 244,
  },
  {
    text: "Libertadores",
    img: libertadores,
    leagueId: 18,
  },
  {
    text: "World Championship",
    img: worldChampionship,
    leagueId: 153,
  },
  {
    text: "CAF Champions",
    img: caf,
    leagueId: 346,
  },
];



